<template>
  <div>
    <!-- Sabit Buton -->
    <button class="feedback-button" @click="open = true">
      💬 Geri Bildirim
    </button>

    <!-- Yan Panel -->
    <div class="feedback-panel" v-if="open">
      <div class="panel-header">
        <span>Geri Bildirim</span>
        <button class="close-button" @click="open = false">×</button>
      </div>
      <textarea v-model="message" placeholder="Görüşlerinizi yazın..."></textarea>
      <button class="submit-button" @click="submit">Gönder</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const open = ref(false)
const message = ref('')

function submit() {
  if (!message.value.trim()) return alert('Lütfen bir mesaj girin')
  // API isteği yapılabilir:
  console.log('Gönderilen geri bildirim:', message.value)
  alert('Teşekkürler! Geri bildiriminiz alındı.')
  message.value = ''
  open.value = false
}
</script>

<style scoped>
.feedback-button {
  position: fixed;
  left: 0;
  top: 50%;
  transform: rotate(-90deg) translateY(-50%);
  transform-origin: left center;
  background-color: #007BFF;
  color: white;
  padding: 10px 20px;
  font-weight: bold;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  cursor: pointer;
}

.feedback-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  height: 100vh;
  background: white;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  margin-bottom: 10px;
}

.close-button {
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

textarea {
  flex-grow: 1;
  resize: none;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 10px;
}

.submit-button {
  background: #28a745;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
